import type { DocMigration } from "../docMigration";

const docRefEligibleFormulaDisabledEntityTypesToDocTableNames = {
  ANNOTATION: "annotation",
  CASEWORK: "casework",
  CONTENT_REPLICATOR: "contentReplicators",
  CONTENT_TEMPLATE_INSTANCE: "contentTemplateInstances",
  DATA_TABLE: "dataTables",
  DRAWING_REF: "drawingRefs",
  ELEVATION: "elevations",
  FACADE: "facades",
  FACADE_SPAN_STRATUM: "facadeSpanStrata",
  FACADE_SWEEP_STRATUM: "facadeSweepStrata",
  GROUP: "groups",
  MODIFIER: "modifiers",
  OPENING: "openings",
  OPTION_SET: "optionSets",
  PROP_INSTANCE: "propInstances",
  ROOM: "rooms",
  SETTINGS_SET: "settingsSets",
  SHEET: "sheets",
  SITE: "sites",
  SITE_SHAPE: "siteShapes",
  VIEWPORT: "viewports",
} as const;

const disabledField = "disabled" as const;

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_463: DocMigration = {
  maxSchemaVersion: "0.0.463",
  description: "Migrate existing doc ref'd entity conditions to entity ref overrides",
  apply(json: any) {
    if (!Object.keys(json.docRefs ?? {}).length) {
      return json;
    }

    if (!Object.keys(json.entityRefs ?? {}).length) {
      return json;
    }

    for (const id in json.entityRefs) {
      const entityRef = json.entityRefs[id];

      /**
       * If there's already a keyed entry in the entity ref, we know that it's
       * either a) an existing entity ref override, or b) already migrated
       */
      if (disabledField in entityRef) {
        continue;
      }

      const docTableName = docRefEligibleFormulaDisabledEntityTypesToDocTableNames[entityRef.entityType];

      if (!docTableName) {
        continue;
      }

      const docTable = json[docTableName];

      if (!Object.keys(docTable ?? {}).length) {
        continue;
      }

      const entity = docTable[id];

      if (!entity) {
        continue;
      }

      const entityDisabled = entity[disabledField];

      json.entityRefs[id][disabledField] = entityDisabled;
    }

    return json;
  },
};

export default migration_0_0_463;
